import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateNotificationPreferences } from '@/services/notifications/update-notification-preferences';
import { NOTIFICATION_PREFERENCES_QUERY_KEY } from '@/hooks/queries/use-get-notification-preferences';
import { NotificationPreference } from '@/types/notification-types';
import { useOrgStore } from '@/stores/org-store';

export const useUpdateNotificationPreferences = () => {
  const queryClient = useQueryClient();
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useMutation({
    mutationFn: (items: NotificationPreference[]) => {
      if (!orgId) throw new Error('No org ID');
      return updateNotificationPreferences(orgId, items);
    },
    // Snapshot the org the request targets so the cache write below can't land
    // on a different org's key if the active org changes mid-flight.
    onMutate: () => ({ orgId }),
    onSuccess: (data, _items, context) => {
      const targetOrgId = context.orgId;
      queryClient.setQueryData(
        [NOTIFICATION_PREFERENCES_QUERY_KEY, targetOrgId],
        data,
      );
      queryClient.invalidateQueries({
        queryKey: [NOTIFICATION_PREFERENCES_QUERY_KEY, targetOrgId],
      });
    },
  });
};
